export default "__VITE_ASSET__4f2e13cc__"